<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统审核配置</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin-top: 20px">
      <el-tabs :value="activeTab" @tab-click="handleDepositTabChange">
        <el-tab-pane label="ERC20" name="erc"></el-tab-pane>
        <el-tab-pane label="TRC20" name="trc"></el-tab-pane>
      </el-tabs>
      <div class="handle-box">
        <el-autocomplete
          class="inline-input"
          v-model="selectedCoin"
          :fetch-suggestions="querySearch"
          placeholder="请输入币种"
          @keyup.native.enter="handleSearch"
        >
          <i
            class="el-icon-close el-input__icon"
            slot="suffix"
            @click="cleanSearchCoin"
            style="cursor: pointer"
          >
          </i>
        </el-autocomplete>
        <div>
          <span>自动过审总开关</span>
          <el-switch v-model="masterSwitch" active-text="启用" inactive-text="停用">
          </el-switch>
          <el-button type="primary">统一配置</el-button>
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="date" label="序号"> </el-table-column>
        <el-table-column prop="name" label="币种"> </el-table-column>
        <el-table-column prop="address" label="链上确认数"> </el-table-column>
        <el-table-column prop="address" label="充值数量校验"> </el-table-column>
        <el-table-column prop="isAuto" label="自动过审状态">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isAuto"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">
              编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import "./store";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      selectedCoin: "",
      activeTab: "erc",
      tableData: [
        {
          date: 1,
          name: "ETH",
          address: "12345645",
          isAuto: true
        },
        {
          date: 2,
          name: "ETH",
          address: "12345645",
          isAuto: false
        }
      ],
      masterSwitch: false
    };
  },
  computed: {
    ...mapState("automaticAudit", ["allCoins"]),
  },
  methods: {
    cleanSearchCoin() {
      this.selectedCoin = "";
    },
    querySearch(queryString, cb) {
      var results = [];
      var coinList = this.allCoins;
      results = queryString
        ? coinList.filter(this.createFilter(queryString))
        : coinList;
      results = results.map((v, i, arr) => {
        return {
          value: v,
        };
      });
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      let tempData = this.allCoins;
      return (tempData) => {
        return tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleDepositTabChange(tab) {
      // this.changeTab(tab.name);
    },
    handleSearch() {},
  },
};
</script>
<style lang='less' scoped>
.handle-box {
  display: flex;
  justify-content: space-between;
  .el-switch {
    padding: 0 20px;
  }
}
</style>
